export const SOCIAL_ICONS = [
  "zealy",
  "twitter",
  "telegram",
  "github",
  "discord",
];

export const PARTNERS_AND_INVESTORS = [
  "image-1",
  "image-2",
  "image-3",
  "image-4",
  "image-5",
  "image-6",
  "image-7",
  "image-8",
  "image-9",
  "image-10",
  "image-11",
  "image-12",
  "image-13",
  "image-14",
  "image-15",
  "image-16",
  "image-17",
  "image-18",
  "image-19",
  "image-20",
  "image-21",
  "image-22",
  "image-23",
  "image-24",
  "image-25",
  "image-26",
  "image-27",
  "image-28",
  "image-29",
  "image-30",
  "image-31",
  "image-32",
  "image-33",
  "image-34",
  "image-35",
  "image-36",
  "image-37",
  "image-38",
  "image-39",
  "image-40",
  "image-41",
  "image-42",
  "image-43",
  "image-44",
  "image-45",
  "image-46",
  "image-47",
  "image-48",
  "image-49",
  "image-50",
  "image-51",
  "image-52",
  "image-53",
  "image-54",
  "image-55",
  "image-56",
  "image-57",
  "image-58",
  "image-59",
  "image-60",
  "image-61",
  "image-62",
  "image-63",
  "image-64",
  "image-65",
  "image-66",
  "image-67",
  "image-68",
  "image-69",
  "image-70",
  "image-71",
  "image-72",
  "image-73",
  "image-74",
  "image-75",
  "image-76",
  "image-77",
  "image-78",
  "image-79",
  "image-80",
  "image-81",
  "image-82",
  "image-83",
  "image-84",
  "image-85",
  "image-86",
  "image-97",
  "image-98",
  "image-99",
  "image-100",
  "image-111",
  "image-112",
  "image-113",
  "image-114",
  "image-115",
  "image-116",
  "image-117",
  "image-118",
  "image-119",
];

export const COMPANIES = [
  "company1",
  "company2",
  "company3",
  "company4",
  "company5",
  "company6",
  "company7",
  "company8",
  "company9",
  "company10",
  "company11",
  "company12",
  "company13",
];

export const EVENTS = [
  "image-1",
  "image-2",
  "image-3",
  "image-4",
  "image-5",
  "image-6",
];
